import axios from 'axios'

import { GeocoderRequestParams, GeocoderResponse } from './types'

export async function requestGeocoder({
  query,
  limit = 5,
  language,
  lat,
  lon,
}: GeocoderRequestParams): Promise<GeocoderResponse> {
  const { data } = await axios.post<GeocoderResponse>(
    '/api/here/geocode',
    {
      atLat: lat,
      atLon: lon,
      language: language,
      q: query,
      limit,
    },
    {
      headers: { 'Accept-Language': i18n?.language ?? 'de' },
    },
  )
  return data
}
